<template>
  <div class="mycollect">
    <van-tabs v-model="active" title-active-color="#3A3A3A" color="#3A3A3A" @click="onClick" sticky>
      <van-tab title="动态">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部"
        :immediate-check="false"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="img.loading" />
        </div>
        <div class="list-box" v-for="(item,index) in blist" :key="'blist_' + item.id">
          <van-row type="flex" justify="space-between">
            <van-col span="4" @click="goMy(item.user.id)">
              <img class="listhand" :src="item.user.headimg_url">
            </van-col>
            <van-col span="16">
              <div class="membername" @click="goMy(item.user.id)">
                {{item.user.user_name}}
              </div>
              <!-- <div class="sourtime">
               这个家伙很懒，什么都没有留下~
             </div> -->
           </van-col>
           <van-col class="bintright" span="4">
            <van-button hidden="true" class="follow" v-if="item.user.is_follow==0" icon="plus" color="#5F5B6B" size="small" @click="follow(index)" :data-code="item.user.id">关 注</van-button>
          </van-col>
        </van-row>
        <router-link :to="{name: 'LexusBbsShow', params: {id: item.id}}">
          <div class="listitle ellipsis-2">{{item.title}}</div>
          <div class="f-15 ellipsis-2">{{item.content}}</div>
        </router-link>
        <div class="pic-box" v-if="item.image.length>0">
          <img class="pic_thumb" v-lazy="item.image[0]">
        </div>
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <span class="binbox">
              <img @click="setPraise(index)" class="binpic" :src="item.is_praise==1? img.collect_have: img.collect">
              <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
            </span>
            <span class="binbox">
              <img class="binpic" :src="img.comment">
              <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
            </span>
            <span class="binbox" hidden="true">
              <img class="binpic" :src="img.inrelay">
              <span class="statenum"></span>
            </span>
          </van-col>
          <van-col class="bintright" span="6" @click="outrelay(item.title,item.content,'/lexus/bbs/'+item.id,item.image[0])">
            <img class="binpic" :src="img.outrelay">
          </van-col>
        </van-row>
        <van-tag v-for="tag in item.topics" :key="'taglist_' + tag.id" color="#F3F9FF" text-color="#728FC4">#{{tag.name}}#</van-tag>
        <div class="binbox" hidden="true">
          <img class="location" :src="img.location">
          <span class="sourtime">济南 · 18:10</span>
        </div>
      </div>
    </van-list>
  </van-tab>
  <van-tab title="新闻">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    :immediate-check="false"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="list-box" v-for="item in list" :key="'list_' + item.id">
      <div v-if="item.module.id==1">
        <router-link :to="{name: 'LexusPostShow', params: {id: item.id}}">
          <van-row gutter="15">
            <van-col span="10">
              <img class="picone" :src="item.pic_url">
            </van-col>
            <van-col span="14">
             <div class="listitle ellipsis-3">
             <!--  <van-tag v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag>
              {{ item.title }} -->
              <h3><van-tag class="mr-10" v-if="item.label!=null" color="#F3F9FF" text-color="#728FC4">{{item.label.name}}</van-tag><span class="posttitle">{{ item.title }}</span>
              </h3>
            </div>
            <div class="sourtime mt-10"><i v-if="item.media!=null">{{item.media.name}}</i>{{item.time_format}}</div>
          </van-col>
        </van-row>
      </router-link>
    </div>
    <div v-if="item.module.id==2">
      <div class="listitle ellipsis-2">
        <router-link :to="{name: 'LexusPicShow', params: {id: item.id}}">
          {{ item.title }}
          <van-tag plain type="danger" v-if="item.label!=null">{{item.label.name}}</van-tag>
        </router-link>
      </div>
      <div class="pic-box" v-if="item.pics.length>0">
        <router-link :to="{name: 'LexusPicShow', params: {id: item.id}}">
          <img class="pic_thumb" fit="cover" :src="item.pics[0].img_url">
        </router-link>
      </div>
      <span class="sourtime">{{item.media.name}}  {{item.time_format}}</span>
    </div>
  </div>
</van-list>
</van-tab>
<van-tab title="问答">
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="已加载全部"
  :immediate-check="false"
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="img.loading" />
  </div>
  <div class="list-box" v-for="item in alist" :key="'alist_' + item.id">
    <div class="listitle listitle2 ellipsis-2">
      <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black">
        <van-tag class="questag" color="#f2826a">Q</van-tag>
        <span class="titleqa">{{ item.question }}</span>
      </router-link>
    </div>
    <div class="f-14">
      <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black">
        {{ item.content }}
      </router-link>
    </div>
    
    <div class="pic-box" v-if="item.image">
      <img class="pic_thumb" fit="cover" :src="item.image">
    </div>
    <van-row type="flex" justify="space-between">
      <van-col span="14">
        <span class="sourtime">{{item.answer_num}}个回答  {{item.collect_num}}个收藏</span>
      </van-col>
      <van-col class="bintright" span="10">
        <span class="sourtime" @click="goPost(5,item.question)">
          <span class="c-blue f-14">我要回答</span>
        </span>
      </van-col>
    </van-row>
  </div>
</van-list>
</van-tab>
<!-- <van-tab title="商城">商城</van-tab> -->
</van-tabs>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="5">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/mycollect';
  import bbs from '../../../api/bbs';
  import content from '../../../api/content';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,ActionSheet,Divider} from 'vant'
  export default {
    data(){
      return{
        active: 0,
        list: [],
        blist:[],
        alist:[],
        page:1,
        channel_id:'',
        user_id:'',
        loading: false,
        finished: false,
        shareshow:false,
        num:10,
        img: {
         parise: require('../../../assets/img/parise.png'),
         parise_have: require('../../../assets/img/parise_have.png'),
         listimg: require('../../../assets/img/member/integral_bg.png'),
         avatar: require('../../../assets/img/lexus/default.png'),
         collect: require('../../../assets/img/lexus/collect.png'),
         collect_have: require('../../../assets/img/lexus/collect_have.png'),
         comment: require('../../../assets/img/lexus/comment.png'),
         inrelay: require('../../../assets/img/lexus/inrelay.png'),
         outrelay: require('../../../assets/img/lexus/outrelay.png'),
         location: require('../../../assets/img/lexus/location.png'),
         loading: require('../../../assets/img/loading_lexus.gif'),
         friends: require('../../../assets/img/lexus/friends.png'),
         wechat: require('../../../assets/img/lexus/wechat.png'),
         link: require('../../../assets/img/lexus/link.png'),
         poster: require('../../../assets/img/lexus/poster.png'),
       }
     }
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.weburl=process.env.VUE_APP_URL
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    let params={
      cid:4,
      page:this.page,
    }
    this.getbbsCollects(params)
    var paramsd={
      event_code: '我的收藏',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/MyCollect.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(paramsd).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    onClick(name){
      if(name==0){
        this.blist=[]
        this.page=1
        let params={
          cid:4,
          page:1
        }
        this.getbbsCollects(params)
      }else if(name==1){
        this.list=[]
        this.page=1
        let params={
         media_id:6,
         page:1
       }
       this.getCollects(params)

     }else{
      this.alist=[]
      this.page=1
      let params={
        channel_id:5,
        page:1
      }
      this.getaskCollects(params)
    }
  },
  getCollects(params){
    list.getCollects(params).then(res => {
      if(res.data.state == 1) {
        let list=this.list
        let newlist=res.data.data.data
        if(list.length==0){
          this.list = res.data.data.data
        }else{
          this.num=newlist.length
          this.list = this.list.concat(newlist)
        }
      }
    })
  },
  getbbsCollects(params){
    list.getbbsCollects(params).then(res => {
      if(res.data.state == 1) {
        let blist=this.blist
        let newlist=res.data.data.data
        if(blist.length==0){
          this.blist = res.data.data.data
        }else{
          this.num=newlist.length
          this.blist = this.blist.concat(newlist)
        }
      }
    })
  },
  getaskCollects(params){
    list.getaskCollects(params).then(res => {
      if(res.data.state == 1) {
        let alist=this.alist
        let newlist=res.data.data.data
        if(alist.length==0){
          this.alist = res.data.data.data
        }else{
          this.num=newlist.length
          this.alist = this.alist.concat(newlist)
        }
      }
    })
  },
  setPraise (index) {
    let type = this.blist[index].is_praise ? 2 : 1;
    bbs.setPraise({id: this.blist[index].id, type: type}).then(res => {
      if(res.data.state == 1) {
        if(type == 1) {
          this.blist[index].is_praise = 1
          this.blist[index].praise_num += 1
        } else {
          this.blist[index].is_praise = 0
          this.blist[index].praise_num -= 1
        }
      }
    })
  },
  onCancel(){
    this.actionshow=false
  },
  outrelay(title,content,url,imageUrl){
    this.shareshow=true
    this.sharetitle=title
    this.sharecontent=content
    this.shareurl=this.weburl+url
    if(imageUrl){
      this.shareimageUrl=imageUrl
    }else{
      this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
    }

  },
  toShare(type){
    var params={
      type:type,
      title:this.sharetitle,
      content:this.sharecontent,
      url:this.shareurl,
      imageUrl:this.shareimageUrl
    }
    this.shareshow=false
    this.$appService.shareContent(params)
  },
  goPost(type,title){
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        var params={
          type:type,
          title:title
        }
        this.show=false
        this.$appService.goPost(params)
      } else {
        this.$appService.needLogin()
      }
    })
  },
  follow(index){
    let type = this.blist[index].user.is_follow==1 ? 2 : 1;
    content.Follow({follow_user_id: this.blist[index].user.id, type: type}).then(res => {
      if(res.data.state == 1) {
        if(type == 1) {
          this.blist[index].user.is_follow=1
          var id=this.blist[index].user.id
          var blist=this.blist
          for(var i=0;i<blist.length;i++){
            if(blist[i].user.id==id){
              var followi=this.blist[i].user.is_follow
              this.blist[i].user.is_follow=1
            }
          }
        } else {
          this.blist[index].user.is_follow=0
          var id=this.blist[index].user.id
          var blist=this.blist
          for(var i=0;i<blist.length;i++){
            if(blist[i].user.id==id){
              this.blist[i].user.is_follow=0
            }
          }
        }
      }
    })
  },
  goMy(id){
    var params={
      url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
      isReturn: true 
    }
    this.$appService.openWebView(params)
  },
  onLoad() {
    setTimeout(() => {
      let num=this.num
      if (num <10) {
        this.finished = true
        this.loading = false
      }else{
        this.page=this.page+1
        if(this.active==0){
          let params={
            cid:4,
            page:this.page
          }
          this.getbbsCollects(params)
        }else if(this.active==1){
          let params={
            media_id:6,
            page:this.page
          }
          this.getCollects(params)
        }else{
          let params={
            channel_id:5,
            page:this.page
          }
          this.getaskCollects(params)
        }
        this.loading = false
      }
    }, 500);
  },
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Button.name]: Button,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [ActionSheet.name]:ActionSheet,
  [Divider.name]:Divider,
}
}
</script>

<style lang="scss">
.mycollect{
  .list-box{
    padding: 15px 10px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:150px;
      height:100px;
      border-radius:1.5px;
      object-fit: cover;
    }
    .ellipsis-3{
      height: 75px;
    }
    h3 {
      font-size: 15px;
      margin: 0;
    }
    .listitle{
      font-size: 15px;
      font-weight:bold;
      line-height: 1.6;
      letter-spacing: 1.4px;
      .titleqa{
        vertical-align: middle;
      }
      .posttitle{
        vertical-align: middle;
      }
    }
    .mt-10{
      margin-top: 10px;
    }
    .statenum{
      font-size: 13px;
      color: #605C6B;
      font-weight: bold;
      vertical-align: middle;
    }
    .sourtime{
      font-size:12px;
      color:rgba(154,154,154,1);
      i {
        font-style: normal;
        padding-right: 10px;
      }
      .c-blue {
        font-size: 12px;
        color: #728FC4;
        background: #F2F6FA url(../../../assets/img/lexus/listask.png) no-repeat 8px center;
        background-size: 13px auto;
        width: 80px;
        height: 25px;
        line-height: 25px;
        display: inline-block;
        text-align: left;
        padding-left: 25px;
        border-radius: 1px;
        box-sizing: border-box;
      }
    }
    .binpic{
      width:15px;
      height:15px;
      margin-right:8px;
      vertical-align: middle;
    }
    .binbox{
      margin-right:20px;
      .location{
        width:12px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
    }
    .bintright{
      text-align:right;
      .van-button--default {
        color: #fff;
        width: 60px;
        height: 26px;
        line-height: 25px;
        font-size: 12px;
        padding: 0;
        background: #5F5B6B
      }
      .van-button__icon{
        font-size: 12px;
      }
      .van-button__text{
        font-size: 12px;
      }
      .binbox{
        margin-left:20px;
      }

    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .pic {
      img {
        width: 100%;
        height: 205px;
        object-fit: cover;
        display: block;
        border-radius: 3px;

        &.right {
          height: 100px;
        }
        &.one {
          margin-bottom: 5px;
        }
      }
      .pic-grid{
        width: 33.33%;
        float: left;
        padding: 5px;
        box-sizing:border-box;
        height: 100px;
      }
    }
    .listhand{
      width:40px;
      height:40px;
      border-radius:1.5px;
    }
    .membername{
      font-size: 13px;
      font-weight: bold;
      line-height: 2.8;
    }
    .van-tag{
      padding: 2px 10px;
      font-size: 12px;
      margin-right: 5px;
    }
    .questag{
      padding: 2px 2px;
      margin-right: 5px;
    }
    .answtag{
      padding: 2px 4px;
      margin-right: 5px;
    }
    .van-grid-item__content{
      padding: 5px 5px;
    }
  }
  .follow{
    vertical-align: super;
  }
  .van-popup{
    .van-action-sheet__cancel::before{
      height: 1px;
    }
    .divider{
      margin: 20px 80px;
    }
  }
}
</style>
